import { CANCEL_DATA_INPUT, CONFIRM_DATA_INPUT } from "./endpoints";
import { fetcher } from "./utils";

export const confirmDataInput = async (testId: string) => {
    const data = await fetcher(CONFIRM_DATA_INPUT, {
        method: "PUT",
        params: {
            test_id: testId,
        },
    });

    return data;
};

export const cancelDataInput = async (testId: string) => {
    const data = await fetcher(CANCEL_DATA_INPUT, {
        method: "PUT",
        params: {
            test_id: testId,
        },
    });

    return data;
};
